import { createContext, useReducer } from 'react';

import stepReducer, { initialState } from '../reducers/stepReducer';
import { StepContextType } from '../types/stepTypes';

export const StepContext = createContext<StepContextType>({
  state: { currentStep: 0 },
  dispatch: () => 0,
});

const StepProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(stepReducer, initialState);

  return (
    <StepContext.Provider value={{ state, dispatch }}>
      {children}
    </StepContext.Provider>
  );
};

export default StepProvider;
